import React from "react";
import { ABOUT_TEXT } from "@/data/content";

export default function About() {
    return (
        <section
            id="nosotros"
            data-testid="about-section"
            className="relative py-24 md:py-32 px-5 md:px-10"
        >
            <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <div className="lg:col-span-5 fade-up">
                    <div className="relative">
                        <div
                            aria-hidden
                            className="absolute -top-6 -left-6 w-full h-full halftone-dots-orange opacity-60"
                        />
                        <img
                            src="https://customer-assets.emergentagent.com/job_luna-markab-retro/artifacts/ffvmkihc_nosotros.webp"
                            alt="Publicidad Luna Markab - parada de autobús iluminada"
                            className="relative w-full h-[420px] md:h-[520px] object-cover border-[6px] border-navy hard-shadow"
                        />
                        <div className="absolute -bottom-5 right-5 bg-navy text-cream border-4 border-navy px-4 py-2 font-display uppercase tracking-widest text-sm">
                            Alto impacto físico
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7 fade-up">
                    <div className="font-display uppercase tracking-[0.3em] text-orange text-sm md:text-base mb-3" style={{ WebkitTextStroke: "1px #326d8e" }}>
                        / Sobre nosotros
                    </div>
                    <h2
                        data-testid="about-title"
                        className="font-heading text-navy text-4xl md:text-6xl lg:text-7xl leading-[1.02]"
                    >
                        Publicitaria
                        <br />
                        <span className="text-teal">Luna Markab</span>
                    </h2>
                    <div className="mt-8 space-y-6 text-navy text-lg md:text-xl font-medium leading-relaxed max-w-2xl">
                        {ABOUT_TEXT.map((t, i) => (
                            <p key={i}>{t}</p>
                        ))}
                    </div>

                    <div className="mt-10 flex flex-wrap gap-3">
                        {[
                            "Publicidad",
                            "Marketing",
                            "Diseño",
                            "Luna",
                            "Markab",
                        ].map((tag) => (
                            <span
                                key={tag}
                                className="border-2 border-navy bg-cream text-navy px-3 py-1 font-display uppercase text-xs tracking-widest"
                            >
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
